export default "__VITE_ASSET__C$2l0MV2__"